import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, normalizeLanguage, DEFAULT_LANGUAGE } from '../i18n/config';
import './LanguageSwitcher.css';

/**
 * Language Switcher
 * Lets the user pick the UI language. The selection is applied immediately and
 * persisted to localStorage by the i18next language detector, so it survives
 * reloads (until overridden by an explicit `?lang=`/`?ui_locales=` URL param).
 */
export const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();

  // i18n.language may carry a region subtag (e.g. `en-US`); normalize for the
  // <select> value so the matching <option> is selected.
  const current = normalizeLanguage(i18n.language) ?? DEFAULT_LANGUAGE;

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <div className="language-switcher">
      <label className="language-switcher__label" htmlFor="language-switcher-select">
        {t('language.switcherLabel')}
      </label>
      <select
        id="language-switcher-select"
        className="language-switcher__select"
        value={current}
        onChange={handleChange}
        aria-label={t('language.switcherLabel')}
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <option key={lng} value={lng}>
            {t(`language.names.${lng}`)}
          </option>
        ))}
      </select>
    </div>
  );
};
